var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('homeHero'),_c('homeSuccess'),_c('homeAdvantages'),_c('homeStores'),_c('homeCities'),_c('homeBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }